import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  getRequiredFields,
  removeEmptyFields,
  setEmptyFieldsToNull,
} from "@/lib/utils";
import {
  YEAR,
  MONTH,
  SCHOOL_NAME,
  GEO_REGION_ID,
  CRM_RH,
  CRM_RM,
  INVOICE_OWNER,
  STATUS,
  DUE_DAYS,
  INVOICE_GENERATION_DATE,
} from "../consts";
import { useIsMobile } from "@/hooks/use-mobile";
import { formValues, schema } from "./validations";
import { useEffect } from "react";

const useFilter = ({
  filterData,
  setFilterData,
  onApply,
  onCancel,
}: {
  filterData: any;
  setFilterData: React.Dispatch<React.SetStateAction<any>>;
  onApply?: (filterData: any) => void;
  onCancel: () => void;
}) => {
  const isMobile = useIsMobile();

  const form = useForm<formValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      [YEAR]: "",
      [SCHOOL_NAME]: "",
      [MONTH]: "",
      [GEO_REGION_ID]: "",
      [CRM_RH]: "",
      [CRM_RM]: "",
      [INVOICE_OWNER]: "",
      [STATUS]: "",
      [DUE_DAYS]: "",
      [INVOICE_GENERATION_DATE]: "",

      
    },
  });

  useEffect(() => {
    if (filterData) {
      form.reset({
        ...filterData,
      });
    }
  }, [filterData]);

  const requiredFields = getRequiredFields(schema);

  const onSubmit = (data: formValues) => {
      // Remove empty/falsy values and keep only non-empty fields
      const cleanedData = Object.entries(data).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {} as Record<string, any>);
      
      setFilterData(cleanedData);
      if (onApply) {
        onApply(cleanedData);
      }
      onCancel();
    };


  const onClear = () => {
    setFilterData(null);
    form.reset({
      [YEAR]: "",
      [MONTH]: "",
        [SCHOOL_NAME]: "",
      [GEO_REGION_ID]: "",
      [CRM_RH]: "",
      [CRM_RM]: "",
      [INVOICE_OWNER]: "",
      [STATUS]: "",
      [DUE_DAYS]: "",
      [INVOICE_GENERATION_DATE]: "",
    })
  };

  return {
    form,
    onSubmit,
    requiredFields,
    isMobile,
    onClear,
  };
};

export default useFilter;
